import {
  QueryStats,
  Receipt,
  ShoppingCart,
  Storefront,
} from '@mui/icons-material'
import { tsMenuItem } from '../../Typescript/UI_Interfaces'
import { useLocalStorage } from 'usehooks-ts'
import { useUserContext } from '../../Contexts/UserConfig'

export function useBioBankMenuItems() {
  const [cart] = useLocalStorage('BioBankShoppingCart', [])
  const { loginConfig } = useUserContext()
  let cartItem: tsMenuItem[] = []
  let saleItems: tsMenuItem[] = []
  let storedItems: tsMenuItem[] = []
  let orders: tsMenuItem[] = []
  if (cart.length) {
    cartItem = [
      {
        path: '/stuart/bio-bank/cart',
        primaryText: 'View Cart',
        leftIcon: <ShoppingCart />,
        badgeCount: cart.length,
      },
    ]
  }
  if (loginConfig?.Modules?.BioBankSaleItems) {
    saleItems = [
      {
        path: '/stuart/bio-bank/',
        primaryText: 'Available Stock',
        leftIcon: <Storefront />,
      },
    ]
  }
  if (loginConfig?.Modules?.BioBankStoredItems) {
    storedItems = [
      {
        path: '/stuart/bio-bank/storage',
        primaryText: 'Stored Items',
        leftIcon: <QueryStats />,
      },
    ]
  }
  if (loginConfig?.Modules?.BioBankOrders) {
    orders = [
      {
        path: '/stuart/bio-bank/order',
        primaryText: 'Orders',
        leftIcon: <Receipt />,
      },
    ]
  }

  return [...cartItem, ...saleItems, ...storedItems, ...orders] as tsMenuItem[]
}
